// extracted by mini-css-extract-plugin
module.exports = {"title":"e_lg","container":"e_mg","right":"e_ng","image":"e_og","scoreLine":"e_pg","scoreRing":"e_qg","badge":"e_rg","badgeImage":"e_sg","badgeRing":"e_tg","large":"e_ug"};